module.exports = __webpack_public_path__ + "static/media/excitement.6d3251c6.png";